<template>
  <div class="loader-message">
    <base-inline-loader height="180" size="md" :stop-animation="$props.hasError || internalFailedTimer"/>
    <transition name="fade" mode="out-in">
      <div v-if="$props.hasError || internalFailedTimer" class="messages" :key="'error-messages'">
        <h2>{{ $t('loadingMessages.errorTitle') }}</h2>
        <p>{{ $t('loadingMessages.errorDescription') }}</p>
        <base-button variant="primary"
                     class="retry-button"
                     @click="handleRetryClick">
          {{ $t('loadingMessages.retryButtonLabel') }}
        </base-button>
      </div>
      <div v-else :key="'message'" class="messages">
        <h2>{{ $t('loadingMessages.title') }}</h2>
        <p>{{ $t('loadingMessages.loadingDescription1') }}</p>
        <p>{{ $t('loadingMessages.loadingDescription2') }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'loader-with-message',
  props: {
    hasError: Boolean
  },
  data () {
    return {
      internalFailedTimer: false,
      tempTimeout: null
    }
  },
  methods: {
    initInternalFailTimer () {
      // after 1 minute, show an error message anyway
      // if the loader is still active after 1 minute,
      // it's likely that the data we fetched is probably not valid
      // and something has failed to initialize in components
      this.internalFailedTimer = false

      this.tempTimeout = setTimeout(() => {
        this.internalFailedTimer = true
        clearTimeout(this.tempTimeout)
        this.tempTimeout = null
      }, 60000)
    },
    handleRetryClick () {
      this.$emit('retry')
      this.initInternalFailTimer()
    }
  },
  mounted () {
    this.initInternalFailTimer()
  }
}
</script>

<style scoped lang="scss">
.loader-message {
  padding-top: 4rem;

  @media (map_get($breakpoints, sm)) {
    padding-top: 6rem;
  }

  @media (map_get($breakpoints, md)) {
    padding-top: 8rem;
  }

  @media (map_get($breakpoints, lg)) {
    padding-top: 10rem;
  }

  @media (map_get($breakpoints, xxl)) {
    padding-top: 12rem;
  }

  .messages {
    text-align: center;
    color: $text;

    h2 {
      font-size: 3.2rem;
      font-weight: normal;
      margin-bottom: 2.4rem;
    }

    p {
      font-size: 1.6rem;
      margin-bottom: 1.6rem;

      &:last-of-type {
        margin-bottom: 4rem;
      }

      @media (map_get($breakpoints, sm)) {
        margin-bottom: 3.2rem;
      }
    }

    .retry-button {
      width: 100%;
      max-width: 280px;
    }
  }
}
</style>
